/**
 *  Wee!! Resursive Depth First Search with visitor!  How's that
 *  for a gang of five implementation! ;)
 *
 *  This is actually a good use case for it, so don't hate me too much.
 *
 *
 * @param dag
 * @param startNode
 * @param visitor
 */
export function depthFirstSearch(dag, startNode, visitor = {}) {
  ensureVisitorContract(visitor)

  // kick off the graph search
  depthFirstSearchRecursive(dag, startNode, null, visitor)
}

/**
 *
 * @param dag
 * @param currentNode
 * @param previousNode
 * @param visitor
 */
function depthFirstSearchRecursive(dag, currentNode, previousNode, visitor) {
  visitor.enterNode({ currentNode, previousNode })

  const neighbors = dag.edges[currentNode.field_id] || []
  neighbors.forEach(nextNodeFieldId => {
    const nextNode = dag.nodes[nextNodeFieldId]
    const canTraverse = visitor.allowTraversal({
      currentNode,
      previousNode,
      nextNode,
    })
    if (canTraverse) {
      depthFirstSearchRecursive(dag, nextNode, currentNode, visitor)
    }
  })

  visitor.leaveNode({ currentNode, previousNode })
}

/**
 * Ensures that the provided visitor has the correct interface
 * @param visitor
 */
function ensureVisitorContract(visitor) {
  visitor.enterNode = visitor.enterNode || EMPTY_FN
  visitor.leaveNode = visitor.leaveNode || EMPTY_FN
  visitor.allowTraversal = visitor.allowTraversal || getDefaultAllowTraversal()
}

function getDefaultAllowTraversal() {
  const visited = {}
  return ({ nextNode }) => {
    // if we've already seen it, don't allow it
    if (visited[nextNode.field_id]) {
      return false
    }

    // if we haven't seen it, add it and allow it
    visited[nextNode.field_id] = nextNode
    return true
  }
}

const EMPTY_FN = () => {}
